import {
	GetCollectionsShowResponse,
	GetScreensShowResponse,
	ManifestKeypadNumbers,
	MediaItem,
} from 'mytours-read-api-typescript'

export interface KeypadItem {
	type: ManifestKeypadNumbers.ItemTypeEnum
	subtype?: GetScreensShowResponse.ScreenTypeEnum | GetCollectionsShowResponse.SubtypeEnum
	id: number
	version: number
	language: string
	title?: string
	icon?: MediaItem
	// Item can only be shown if at least one of the collections is unlocked. undefined means the item is always accessible
	collectionIds?: number[]
}

export interface KeypadItemError {
	errorMessage: string
}

export enum KeypadEntryStatus {
	Processing = 'processing',
	Failed = 'failed',
}

export enum ScannerItemType {
	App = 'app',
	Collection = 'collection',
}
